import React from 'react';
import Layout from '../../shared/components/Layout';
import Complete from '@/components/Complete';

const CommercialLensComplete: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <Complete id="page-facility_login" heading="製品レンズ注文完了" content="製品レンズの注文が完了しました。"  />
      </Layout>
    </React.Fragment>
  )
}

export default CommercialLensComplete;